(function () {
'use strict';

var documentInit;

(function ($) {

	documentInit = function () {
		new Document();
	};

	class Document {
		constructor() {
			this.init();
			this.bind();
		}

		init() {
			this.$body = $(document.body);

			document.headerHeightScrolled = 100;
		}

		bind() {
			$(window).scroll((e) => { this.scroll(); });
		}

		scroll() {

			var scroll = window.scrollY;

			if (scroll > 0 && !this.$body.hasClass('is-scrolled')) {
				this.$body.addClass('is-scrolled');
				return;
			}

			if (scroll == 0 && this.$body.hasClass('is-scrolled')) {
				this.$body.removeClass('is-scrolled');
				return;
			}

		}

	}

})(jQuery);

var documentInit$1 = documentInit;

var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	};

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	};

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();
			console.log(this);

		}
		init() {
			this.$trigger = $(selectors.trigger, this.$container);
			this.$links = $('a', this.$container).not(this.$trigger);
		}

		bind() {
			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

	}

})(jQuery);


var mobileNavInit$1 = mobileNavInit;

var slickInit;

(function ($) {

	slickInit = function () {

		$('.o-slider-section__sliders').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				autoplay: true,
				autoplaySpeed: 3000,
				speed: 1000,
				arrows: false,
				pauseOnHover: false,
				dots: true,
				rows: 0,
				loop: true,
				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});
			$(".slick-dots").wrap("<div class=\"o-section \"><div class=\"o-grid\"><div class=\"o-grid__col u-pl--0@md\"></div></div></div>");

		});
		$('.c-home-zespol__wrap').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				infinite: true,
				slidesToShow: 5,
				slidesToScroll: 1,
				swipe: true,
				swipeToSlide: true,
				arrows: false,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1
						}
					}
				],
				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});


		});
		$('.c-home-projekty__wrap').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				swipe: true,
				swipeToSlide: true,
				arrows: false,

				responsive: [
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2
						}
					}
				],

				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});


		});
		$('.c-home-aktualnosci__wrap').each((i, el) => {

			new SlickSlider(el, {
				// fade: true,
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				swipe: true,
				swipeToSlide: true,
				arrows: false,

				events: {
					init: function (e, slick) {
						setTimeout(_ => {
							slick.$slides.eq(0).addClass('is-in-view');
						}, 10);
					},
					beforeChange: function (e, slick, currentSlide, nextSlide) {
						slick.$slides.eq(nextSlide).addClass('is-in-view');
					},
					afterChange: function (e, slick, currentSlide) {
						slick.$slides.not(':eq(' + currentSlide + ')').removeClass('is-in-view');
					}
				}
			});


		});

	};

	class SlickSlider {

		constructor(el, options) {

			this.$slider = $(el);

			this.events = options.events || false;
			delete options.events;

			this.options = options;

			if (this.$slider.length) {
				this.bind();
				this.init();
			}
		}

		bind() {

			this.onResize = this.onResize.bind(this);

			$(window).on('resize', this.onResize);

			const self = this;
			if (self.events) {
				$.each(self.events, (event, callback) => {
					self.$slider.on(event, callback);
				});
			}

		}

		init() {
			this.$slider.slick(this.options);
		}

		onResize() {
			// console.log('hello');
			if (!this.$slider.hasClass('slick-initialized')) {
				this.init();
			}
		}


	}


})(jQuery);


var slickInit$1 = slickInit;

var miscInit;

(function ($) {

	const selectors = {
		scrollTop: '[data-scroll-top]',
		scrollInidicator: '[data-scroll-indicator]'
	};

	miscInit = function () {

		$(selectors.scrollTop).click(function (e) {
			e.preventDefault();
			$('html, body').stop().animate({ scrollTop: 0 }, 1000);
		});

		$('a[href^="#"]:not([href="#"])').on('click', function (e) {
			e.preventDefault();

			const target_id = $(this).attr('href').slice(1);
			const $target = $('#' + target_id + ', [data-id="' + target_id + '"]').filter(':visible');

			if ($target.length) {
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 100 }, 1000);
			}

		});

		$(selectors.scrollInidicator).on('click', function (e) {
			e.preventDefault();

			var $next_section = $(this).closest('main > *').next();
			if ($next_section.length) {

				$next_section = $next_section.first();

				const header_height = $(window).width >= 900 ? 80 : 70;
				const win_height = $(window).height() - header_height;
				const offTop = $next_section.offset().top - header_height - parseFloat($next_section.css('margin-top'));

				$('html, body').stop().animate({ scrollTop: offTop });
			}
		});

	};

})(jQuery);

var miscInit$1 = miscInit;

var projectFilterInit;

(function ($) {

	const selectors = {
		wrap: '[data-projects]',
		item: '[data-projects-project]',
		filtersWrap: '[data-projects-filters]',
		filter: '[data-projects-filter]',
		trigger: '[data-projects-filters-trigger]',
		content: '[data-projects-filters-content]',
		topFilter: '[data-projects-filter]', // Selector for top-level filters
		topMenuSubcategories: '.c-projects__filtry-top-menu .c-projects__subcategories' // Subcategories container
	};

	projectFilterInit = function () {
		$(selectors.wrap).each((i, el) => { new ProjectFilter(el); });
	};

	class ProjectFilter {

		constructor(el) {

			this.$wrap = $(el);

			if (this.$wrap.length) {
				this.init();
				this.bind();
			}
		}

		bind() {

			const self = this;

			this.$filter.on('click', this.onFilterClicked.bind(this));
			$(selectors.topMenuSubcategories).on('click', selectors.filter, this.onSubFilterClicked.bind(this)); // Bind click for subcategories

			$(window).on('load', () => { self.$wrap.isotope('layout'); });

			// Bind click event for each filtersWrap to toggle visibility
			this.$trigger.each((i, wrap) => {
				const $wrap = $(wrap);
				$wrap.on('click', (e) => {
					e.stopPropagation();  // Prevents the click event from bubbling up

					if ($wrap.closest(this.$filtersWrap).hasClass('filters-visible')) {
						this.hideFilters($wrap.closest(this.$filtersWrap));
					} else {
						this.hideAllFilters();  // Hide all other dropdowns
						this.showFilters($wrap.closest(this.$filtersWrap));
					}
				});
			});


		}

		init() {

			this.$filtersWrap = $(selectors.filtersWrap);
			this.$filter = $(selectors.filter);
			this.$trigger = $(selectors.trigger, this.$filtersWrap);
			this.$content = $(selectors.content, this.$filtersWrap);
			this.$topFilter = $(selectors.topFilter);

			this.$wrap.isotope({
				// options
				itemSelector: selectors.item,
				// layoutMode: 'fitRows'
			});

		}

		onFilterClicked(e) {

			e.preventDefault();

			const $filter = $(e.target);
			// Check if the clicked element has the class 'c-projects__link'
			if ($filter.hasClass('c-projects__subcategory')) {
				return; // Exit the function if it does
			}
			if (!$filter.length) return;

			this.$filter.removeClass('is-active');
			$filter.addClass('is-active');

			const filter = $filter.attr('data-projects-filter');
			const filterType = $filter.attr('data-filter-type');  // New attribute to determine filter type (category or featured)

			// Show the corresponding subcategories
			this.showSubcategories(filter);

			let filterSelector = '';

			if (filter == '*') {
				filterSelector = '*';
				this.$filtersWrap.removeClass('is-active');
			} else {
				this.$filtersWrap.addClass('is-active');

				// Check the filter type and build the selector accordingly
				if (filterType === 'markets') {
					filterSelector = '[data-markets*="' + filter + '"]';
				} else if (filterType === 'featured') {
					filterSelector = '[data-featured*="' + filter + '"]';
				}
				else if (filterType === 'services') {
					filterSelector = '[data-services*="' + filter + '"]';
				}
			}

			this.$wrap.isotope({ filter: filterSelector });

			//this.hideFilters();
		}

		onSubFilterClicked(e) {
			e.preventDefault();

			const $filter = $(e.target);
			if (!$filter.length) return;


			this.$filter.removeClass('is-active');
			$filter.addClass('is-active');


			const filter = $filter.attr('data-projects-filter');
			const filterType = $filter.attr('data-filter-type');

			let filterSelector = '';

			if (filter == '*') {
				filterSelector = '*';
			} else {
				// Check the filter type and build the selector accordingly
				if (filterType === 'markets') {
					filterSelector = '[data-markets*="' + filter + '"]';
				} else if (filterType === 'featured') {
					filterSelector = '[data-featured*="' + filter + '"]';
				}
				else if (filterType === 'services') {
					filterSelector = '[data-services*="' + filter + '"]';
				}
			}


			this.$wrap.isotope({ filter: filterSelector });

			// Keep the top-level filter active and highlight the subcategory
			const topFilter = $filter.closest(selectors.topMenuSubcategories).attr('data-projects-top-filter');
			console.log($(`[data-projects-filter="${topFilter}"]`));
			$(`[data-projects-filter="${topFilter}"]`).addClass('is-active');
		}

		showSubcategories(filter) {

			const $subcategories = $(selectors.topMenuSubcategories);

			// Hide all subcategories
			$subcategories.hide();

			// Show the subcategories matching the clicked filter
			$subcategories.filter(`[data-projects-top-filter="${filter}"]`).slideDown();
		}

		showFilters($wrap) {
			$wrap.addClass('filters-visible');
			$wrap.find(selectors.content).stop().fadeIn();
		}

		hideFilters($wrap) {
			$wrap.removeClass('filters-visible');
			$wrap.find(selectors.content).stop().fadeOut();
		}

		hideAllFilters() {
			this.$filtersWrap.removeClass('filters-visible');
			this.$content.stop().fadeOut();
		}


	}


})(jQuery);


var projectFilterInit$1 = projectFilterInit;

(function ($) {

	$(document).on('afterLoad.fb', function (e, instance, slide) {
		slide.$slide.closest('.fancybox-container').find('[data-fancybox-close]').fadeIn();
	});

	$(document).ready(function () {

		documentInit$1();
		mobileNavInit$1();
		slickInit$1();
		miscInit$1();
		projectFilterInit$1();

		$(window).trigger('scroll');

	});

})(jQuery);

}());
